"use client";

import {
	type DefaultImageProps,
	type DefaultLinkProps,
	Image,
	Link
} from "@pamperedchef/design-system";
import * as styles from "./MinimalHeader.module.scss";

export interface MinimalHeaderProps {
	/** Full URL to the brand logo asset (locale/country resolved upstream). */
	logoSrc: string;
	logoAlt?: string;
	/** Where the logo link points. Defaults to the locale root. */
	logoHref?: string;
}

/**
 * Minimal page header — just the centered brand logo on a white bar.
 *
 * Used by landing pages whose `basic_page.page_layout = "Minimal"`. Mirrors
 * the legacy `LogoHeader` (`src/composite/LogoHeader`) the `/quiz` route
 * uses, but lives in the isolated composites layer so it stays packageable.
 */
export function MinimalHeader({
	logoSrc,
	logoAlt = "Pampered Chef",
	logoHref = "/"
}: MinimalHeaderProps): JSX.Element {
	return (
		<header className={styles.header} data-component="MinimalHeader">
			<div className={styles["logo-container"]}>
				<Link<DefaultLinkProps>
					href={logoHref}
					title="Home"
					className={styles.logo}
				>
					<Image<DefaultImageProps>
						src={logoSrc}
						alt={logoAlt}
						className={styles["logo-image"]}
					/>
				</Link>
			</div>
		</header>
	);
}
